module.exports = __webpack_public_path__ + "img/Hand_31_05_15.5aa20d67.png";